import { KameleoonExperimentIds, KameleoonExperimentsVariantIds } from '@/hooks/kameleoon/kameleoonExperiments';

/**
 * Do not use this function directly! Use the corresponding experiment's hooks.
 */
// Keeping this here for now to avoid breaking changes, but it's not used anywhere
export const useExperimentBase = (
    featureFlagKey: KameleoonExperimentIds,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    featureFlagVariant: KameleoonExperimentsVariantIds[typeof featureFlagKey]
) => {
    return false;
};
